// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './locales/index'
import './filter/index'
import Vant from 'vant';
import 'vant/lib/index.css';

// 注入 CSS 根变量
Vue.prototype.IMG_API = process.env.IMG_API
Vue.use(Vant)

Vue.use(i18n)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js